import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPelotonComponent } from './simple-icons-peloton.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPelotonComponent ],
    exports:      [ SimpleIconsPelotonComponent ],
    bootstrap:    []
})
export class SimpleIconsPelotonModule {}
